
export default function ({ $axios, redirect, req }) {
  let replaced = null;
  $axios.onRequest(config => {
    if (replaced === null) {
      let appySite;
      if ((typeof req !== 'undefined' &&
        typeof req.headers !== 'undefined' &&
        req.headers.host !== null &&
        /.*appylife\.com.*/ig.test(req.headers.host))
        ||
        (typeof window !== 'undefined' &&
          window.location !== 'undefined' &&
          window.location.host !== null &&
          /.*appylife\.com.*/ig.test(window.location.host)
        )
      ) {
        appySite = {
          site: 'AL',
          domain: 'appylife.com',
        }
      } else {
        appySite = {
          site: 'AC',
          domain: 'appycouple.com'
        }
      }

      const regex = /(\w+\.com)/m;
      const str = config.baseURL;
      const subst = appySite.domain;

      replaced = str.replace(regex, subst);
      $axios.defaults.baseURL = replaced;
      config.baseURL = replaced;
      // console.log('Making replacement ' + config.baseURL, config);
    }
    else {
      $axios.defaults.baseURL = replaced;
      config.baseURL = replaced;
      // console.log('alread replaced ' + config.baseURL)
    }
    return config
  })
}
